const isAfterToday = (dateToCheck: Date): boolean => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const target = new Date(dateToCheck);
  target.setHours(0, 0, 0, 0);

  return target > today;
};

export default isAfterToday;
